import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import useEmblaCarousel from "embla-carousel-react";

// Configuration object for sponsor logos (hanya tinggi, lebar auto)
const sponsors = [
  {
    src: "/partners/tnggp.jpg",
    alt: "TNGGP",
    mobile: { height: "h-20" },
    desktop: { maxHeight: "md:max-h-32" },
  },
  {
    src: "/partners/koni.webp",
    alt: "KONI",
    mobile: { height: "h-20" },
    desktop: { maxHeight: "md:max-h-32" },
  },
  {
    src: "/partners/dispora.webp",
    alt: "Dispora",
    mobile: { height: "h-28" },
    desktop: { maxHeight: "md:max-h-36" },
  },
  {
    src: "/partners/alti.png",
    alt: "ALTI",
    mobile: { height: "h-24" },
    desktop: { maxHeight: "md:max-h-36" },
  },
  {
    src: "/partners/kemenpora.png",
    alt: "Kemenpora",
    mobile: { height: "h-24" },
    desktop: { maxHeight: "md:max-h-36" },
  },
];

export const SectionPartner = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [emblaRef] = useEmblaCarousel({
    loop: false,
    align: "start",
    dragFree: true,
    containScroll: "trimSnaps",
  });

  // Detect screen width to enable Embla Carousel below 1024px
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1024);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section id="sponsors" className="w-full py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          {/* Title */}
          <div className="text-center mb-8">
            <motion.h2
              className="text-2xl font-black uppercase tracking-wider text-lime-600"
              initial={{ opacity: 0, y: -15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
            >
              EVENT
            </motion.h2>
            <motion.h3
              className="text-3xl md:text-5xl font-black text-lime-600 mt-2"
              initial={{ opacity: 0, y: -15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
            >
              PARTNER
            </motion.h3>
          </div>

          <div className="lg:py-10">
            {sponsors.length === 1 ? (
              // Single logo layout
              <div className="flex justify-center items-center">
                <motion.div
                  className="flex justify-center items-center"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, ease: "easeOut" }}
                >
                  <img
                    src={sponsors[0].src}
                    alt={sponsors[0].alt}
                    className={`object-contain w-auto ${sponsors[0].mobile.height} ${sponsors[0].desktop.maxHeight}`}
                    onError={(e) => {
                      e.target.src =
                        "https://via.placeholder.com/400x100?text=Sponsor+Image";
                    }}
                  />
                </motion.div>
              </div>
            ) : isSmallScreen ? (
              // Embla Carousel for small screens
              <div className="overflow-hidden px-4" ref={emblaRef}>
                <div className="flex flex-col md:flex md:flex-row gap-y-8 md:gap-20 items-center">
                  {sponsors.map((sponsor, index) => (
                    <motion.div
                      key={index}
                      className="flex justify-center items-center"
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{
                        duration: 0.5,
                        delay: index * 0.1,
                        ease: "easeOut",
                      }}
                    >
                      <img
                        src={sponsor.src}
                        alt={sponsor.alt}
                        className={`object-contain w-auto ${sponsor.mobile.height}`}
                        onError={(e) => {
                          e.target.src =
                            "https://via.placeholder.com/400x100?text=Sponsor+Image";
                        }}
                      />
                    </motion.div>
                  ))}
                </div>
              </div>
            ) : (
              // Flex layout for larger screens
              <div className="flex flex-col md:flex md:flex-row overflow-y-auto md:justify-center gap-y-6 md:gap-20 mx-auto w-full max-w-7xl items-center">
                {sponsors.map((sponsor, index) => (
                  <motion.div
                    key={index}
                    className="flex justify-center items-center"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                      duration: 0.5,
                      delay: index * 0.1,
                      ease: "easeOut",
                    }}
                  >
                    <img
                      src={sponsor.src}
                      alt={sponsor.alt}
                      className={`object-contain w-auto ${sponsor.desktop.maxHeight}`}
                      onError={(e) => {
                        e.target.src =
                          "https://via.placeholder.com/400x100?text=Sponsor+Image";
                      }}
                    />
                  </motion.div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
